import { User } from './../../models/user.model';
import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {Subject} from "rxjs";
import {environment} from "../../../environments/environment";
import {LoaderService} from "../../service/loader.service";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {ThemeService} from "../../service/theme.service";
import {UserService} from "../../service/user.service";
import {Router} from "@angular/router";
import {RoutesEnum} from "../../shared/enums/routes.enum";
import {MultiApp} from "../../models/multi-app.model";
import {BreadcrumbService} from "../../service/breadcrumb.service";
import {TriagemService} from "../../service/triagem.service";
import { GroupEnum } from 'src/app/shared/enums/group.enum';
import { Group } from 'fabric/fabric-impl';

@Component({
  selector: 'app-multi-apps',
  templateUrl: './multi-apps.component.html',
  styleUrls: ['./multi-apps.component.scss']
})
export class MultiAppsComponent implements OnInit, OnDestroy {
  private readonly _destroy$: Subject<void> = new Subject<void>();
  isLogged: boolean = false;
  iframeHeight: number = 0;
  iframeLoaded: boolean = false;
  urlIframe: SafeResourceUrl | null = null;
  GroupEnum = GroupEnum

  apps: MultiApp[] = [

  ]

  constructor(public loaderService: LoaderService,
              public themeService: ThemeService,
              public router: Router,
              public breadCrumb: BreadcrumbService,
              public authService: UserService,
              public triagemService: TriagemService,
              public sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.buildNexusCards();
    this.themeService.disableHubMenu();
    this.breadCrumb.next([]);
    localStorage.removeItem('app-selected');
    this.themeService.setSelectedApp('');
    this.themeService.disableFrameworkMenu();
    this.themeService.reloadNexus$.subscribe(() => {
      this.buildNexusCards();
    })
    this.iframeHeight = window.innerHeight - 50;
  }

  ngOnDestroy() {
    this.isLogged = false;
    this._destroy$.next();
    this._destroy$.complete();
    this.themeService.enableFrameworkMenu();

    this.themeService.enableHubMenu();
    this.loaderService.hideLoader();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.iframeHeight = window.innerHeight - 50;
  }

  buildNexusCards(){
    this.apps =
    [
      {
        name: 'Administrador',
        url: ``,
        id: 'administrador',
        logo:'',
        background:'/assets/images/falcon/bg2-scaledown.jpg',
        disabled: !this.hasModules(6),
        imgs: [
          '/assets/images/falcon/1.png',
          '/assets/images/falcon/2.png',
          '/assets/images/falcon/3.png',
          '/assets/images/falcon/4.png',
          '/assets/images/falcon/5.png',
        ],
        resumo: 'O Falcon é uma plataforma avançada de vigilância desenvolvida para cidades inteligentes, oferecendo monitoramento em tempo real, análise estatística e inteligência de negócios (BI) para otimização da segurança pública e gestão urbana.',
        descricao: 'Vigilancia ativa para cidades inteligentes',
        img: '/assets/images/velsinho/Pose 4 com sombra.png'
      },
      {
        name: 'Processamento',
        url: `${environment.apps.falcon_web}/`,
        id: 'processamento',
        logo:'/assets/images/framework/audit_logo.png',
        background:'/assets/images/falcon/bg2-scaledown.jpg',
        disabled: !this.hasModules(3),
        imgs: [
          '/assets/images/falcon/1.png',
          '/assets/images/falcon/2.png',
          '/assets/images/falcon/3.png',
          '/assets/images/falcon/4.png',
          '/assets/images/falcon/5.png',
        ],
        resumo: 'O Falcon é uma plataforma avançada de vigilância desenvolvida para cidades inteligentes, oferecendo monitoramento em tempo real, análise estatística e inteligência de negócios (BI) para otimização da segurança pública e gestão urbana.',
        descricao: 'Vigilancia ativa para cidades inteligentes',
        img: '/assets/images/velsinho/Pose 4 com sombra.png'
      },
      {
        name: 'Falcon',
        url: `${environment.apps.falcon_web}/`,
        id: 'falcon',
        logo:'/assets/images/falcon/falcon_logo.png',
        background:'/assets/images/falcon/bg2-scaledown.jpg',
        disabled: !this.hasModules(2),
        imgs: [
          '/assets/images/falcon/1.png',
          '/assets/images/falcon/2.png',
          '/assets/images/falcon/3.png',
          '/assets/images/falcon/4.png',
          '/assets/images/falcon/5.png',
        ],
        resumo: 'O Falcon é uma plataforma avançada de vigilância desenvolvida para cidades inteligentes, oferecendo monitoramento em tempo real, análise estatística e inteligência de negócios (BI) para otimização da segurança pública e gestão urbana.',
        descricao: 'Vigilancia ativa para cidades inteligentes',
        img: '/assets/images/velsinho/Pose 4 com sombra.png'
      },
      {
        name: 'Pulse',
        url: ``,
        disabled: !this.hasModules(4),
        id: 'pulse',
        logo:'/assets/images/framework/pulsevs_beta_logo.png',
        background:'/assets/images/framework/bg2-scaledown.jpg',
        imgs: [
          '/assets/images/framework/1.png',
          '/assets/images/framework/2.png',
          '/assets/images/framework/3.png',
          '/assets/images/framework/4.png',
          '/assets/images/framework/5.png',
        ],
        descricao: 'Monitoramento',
        resumo: 'O Pulse é um sistema completo para monitoramento.',
        img: '/assets/images/velsinho/Pose 5 com sombra.png'
      },
      {
        name: 'TrackerVS',
        url: ``,
        disabled: !this.hasModules(1),
        id: 'tracker',
        logo:'/assets/images/tracker/tracker_logo.png',
        background:'/assets/images/tracker/bg2-scaledown.jpg',
        imgs: [
          '/assets/images/tracker/1.png',
          '/assets/images/tracker/2.png',

        ],
        descricao: 'Monitoramento e processamento de imagens',
        resumo: 'O PulseVS é um sistema completo para monitoramento, processamento de imagens e gestão de usuários. Ele integra diversas funcionalidades para otimizar a análise de dados visuais e a administração do ambiente operacional.',
        img: '/assets/images/velsinho/Pose 5 com sombra.png'
      },
      {
        name: 'IOT Manager',
        url: ``,
        disabled: !this.isVelser('iotmanager'),
        id: 'iotManager',
        logo:'',
        background:'/assets/images/tracker/bg2-scaledown.jpg',
        imgs: [
          '/assets/images/tracker/1.png',
          '/assets/images/tracker/2.png',

        ],
        descricao: 'Monitoramento e processamento de imagens',
        resumo: 'O PulseVS é um sistema completo para monitoramento, processamento de imagens e gestão de usuários. Ele integra diversas funcionalidades para otimizar a análise de dados visuais e a administração do ambiente operacional.',
        img: '/assets/images/velsinho/Pose 5 com sombra.png'
      },
    ]
  }

  hasModules(moduleId:number){
    const currentContract = this.authService.getCurrentContract();
    const permissionContract: any = this.authService.user.permissions?.find(
      (p: any) => p.contractId === currentContract?.id
    );
    return permissionContract?.profiles?.some((profile:any) =>
      profile.profileModuleScreens.some((pms:any) => pms.module.id === moduleId)
    );
  }

  isVelser(appId: any){
    if(appId && appId === 'iotManager'){
      return (
        this.authService.user.email.toLowerCase().includes("velsis") &&
        (
          this.authService.getCurrentContract()?.id == GroupEnum.SIMOES_FILHO ||
          this.authService.getCurrentContract()?.id == GroupEnum.PRF
        )
      );
    }else{
      return true
    }
  }

  isAdm(appId: any) {
    if (appId && appId === 'administrador') {
      const contract = this.authService.getCurrentContract();
      return contract?.id === GroupEnum.SANTAMARIA || contract?.contractOriginId === GroupEnum.SANTAMARIA;
    } else {
      return true;
    }
  }

  handleSelect(app: MultiApp) {
    if (app.disabled)
      return;

    if(app.id === 'iotManager'){
      localStorage.setItem('app-selected', app.id ?? '-1');
      this.buildUrlByAppID(app);
      return;
    }
    if(app.id === 'administrador'){
      localStorage.setItem('app-selected', app.id ?? '-1');
      this.buildUrlByAppID(app);
      return;
    }
    this.isLogged = false;
    this.iframeHeight = window.innerHeight - 51;
    this.loaderService.showLoader();
    localStorage.setItem('app-selected', app.id ?? '-1');
    this.buildUrlByAppID(app);

    setTimeout(() => {
      this.isLogged = true;
      this.onResize();
    }, 100);
  }

  onIframeLoad() {
    this.breadCrumb.next([]);
    setTimeout(() => {
      this.iframeLoaded = true;
      this.loaderService.hideLoader();
    }, 1500);

    this.themeService.enableHubMenu();
  }

  buildUrlByAppID(app: MultiApp): void {
    switch (app.id) {
      case 'falcon':
        this.router.navigate([RoutesEnum.IFRAME_FALCON_GENERAL]).then(() => {
        });
        break;
      case 'pulse':
        this.themeService.setSelectedApp(app.id);
        this.router.navigate([RoutesEnum.REAL_TIME]).then(() => {
        });
        break;
      case 'tracker':
        this.themeService.setSelectedApp(app.id);
        this.router.navigate([RoutesEnum.TRACKERVS_GENERAL]).then(() => {
        });
        break;
      case 'processamento':
        this.themeService.setSelectedApp(app.id);
        this.router.navigate([RoutesEnum.PROCESSAMENTO_PRIMEIRA_TRIAGEM]).then(() => {
        });
        break;
      case 'iotManager':
        const iotUrl = this.buildIotManagerUrl();
        window.open(iotUrl, '_blank', 'noopener');
        break;
      case 'administrador':
        const adminUrl = this.buildAdminUrl();
        window.open(adminUrl, '_blank', 'noopener');
        break;
      default:
        this.urlIframe = this.sanitizer.bypassSecurityTrustResourceUrl(
          `${environment.apps.falcon_web}/`
        );
        break;
    }
  }

  private buildIotManagerUrl(): string {
    const baseUrl = environment.apps.iot_manager;
    const userLogin = encodeURIComponent(this.authService.user.email.split("@")[0] ?? '');
    return `${baseUrl}/login?user=${userLogin}`;
  }

  private buildAdminUrl(): string {
    const baseUrl = environment.apps.administrador;
    return `${baseUrl}/login`;
  }
}
